module.exports = __webpack_public_path__ + "img/accounts-payable.f97cc833.svg";